import React from "react";
import { Box, Typography } from "@mui/material";
import FormButton from "../FormButton";
import { useTranslation } from "../../hooks/useTranslation";

interface FaultStepProps {
  accidentFault: string;
  onChange: (field: string, value: string) => void;
  setDequalified: () => void; // For the third option
}

const FaultStep: React.FC<FaultStepProps> = ({
  accidentFault,
  onChange,
  setDequalified,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h6" align="center" sx={{ color: "#c6c6c6", mb: 2 }}>
        Question 3 out of 5
      </Typography>
      <Typography variant="h6" align="center" sx={{ mb: 3 }}>
        3. {t("form.thirdQuestion.question")}{" "}
        <span style={{ color: "red" }}>*</span>
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <FormButton
          isSelected={accidentFault === "NO"}
          onClick={() => onChange("accidentFault", "NO")}
        >
          {t("form.thirdQuestion.option1")}
        </FormButton>

        <FormButton
          isSelected={accidentFault === "YES"}
          onClick={() => onChange("accidentFault", "YES")}
        >
          {t("form.thirdQuestion.option2")}
        </FormButton>

        <FormButton isSelected={false} onClick={setDequalified}>
          {t("form.thirdQuestion.option3")}
        </FormButton>
      </Box>
    </>
  );
};

export default FaultStep;
